/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { MetricsControllerIndexQueryResponse } from '../../types/MetricsControllerIndex.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { metricsIndex } from '../../methods/metricsIndex.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const metricsIndexQueryKey = () => [{ url: '/metrics' }] as const;

export type MetricsIndexQueryKey = ReturnType<typeof metricsIndexQueryKey>;

export function metricsIndexQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = metricsIndexQueryKey();
  return queryOptions<
    MetricsControllerIndexQueryResponse,
    ResponseErrorConfig<Error>,
    MetricsControllerIndexQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return metricsIndex(config);
    },
  });
}

/**
 * {@link /metrics}
 */
export function useMetricsIndex<
  TData = MetricsControllerIndexQueryResponse,
  TQueryData = MetricsControllerIndexQueryResponse,
  TQueryKey extends QueryKey = MetricsIndexQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        MetricsControllerIndexQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? metricsIndexQueryKey();

  const query = useQuery(
    {
      ...metricsIndexQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
